import { render, staticRenderFns } from "./AuditoriaComponent.vue?vue&type=template&id=7d966b2c&scoped=true"
import script from "./AuditoriaComponent.vue?vue&type=script&lang=js"
export * from "./AuditoriaComponent.vue?vue&type=script&lang=js"
import style0 from "./AuditoriaComponent.vue?vue&type=style&index=0&id=7d966b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d966b2c",
  null
  
)

export default component.exports